import React, { useState, useCallback } from 'react';
import moment from 'moment-timezone';

type UserInfoModalProps = {
    isOpen: boolean;
    roleLabel: string;
    user: { name?: string | null; email: string; granted_at: number | null } | null;
    onClose: () => void;
    onRemove: () => Promise<void>;
};

const formatDate = (timestamp: number | null): string => {
    if (!timestamp) { return '-'; }
    return moment(timestamp * 1000).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm');
};

const UserInfoModal: React.FC<UserInfoModalProps> = ({ isOpen, roleLabel, user, onClose, onRemove }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleRemove = useCallback(async () => {
        if (isSubmitting) { return; }

        setIsSubmitting(true);
        try {
            await onRemove();
            onClose();
        } finally {
            setIsSubmitting(false);
        }
    }, [isSubmitting, onRemove, onClose]);

    if (!isOpen || !user) { return null; }

    return (
        <>
            <div className="ModalOverlay active" onClick={onClose}></div>
            <div className="UserInfo Modal active" onClick={(e) => e.stopPropagation()}>
                <div className="ModalContent">
                    <div className="ModalHeader">
                        <h2 className="ModalTitle">{roleLabel} 정보</h2>
                    </div>
                    <div className="ModalBody">
                        <div className="QuestionSection">
                            <div className="ProfileSection">
                                <div className="ProfileImageLarge"></div>
                                <div className="ProfileInfo">
                                    <p className="UserNameLarge">{user.name || user.email.split('@')[0]}</p>
                                    <p className="UserEmailLarge">{user.email}</p>
                                </div>
                            </div>
                            <div className="InfoBox">
                                <div className="InfoItem">
                                    <p className="InfoLabel">권한부여일</p>
                                    <p className="InfoValue">{formatDate(user.granted_at)}</p>
                                </div>
                                <div className="InfoDivider"></div>
                                <div className="InfoItem">
                                    <p className="InfoLabel">최근 접속일</p>
                                    <p className="InfoValue">{"-"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ModalFooter">
                        <button className="ModalButton DeleteButton" onClick={handleRemove} disabled={isSubmitting}>
                            {isSubmitting ? '처리 중...' : `${roleLabel} 삭제하기`}
                        </button>
                        <button className="ModalButton TertiaryButton" onClick={onClose}>닫기</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserInfoModal;
